module.exports = __webpack_public_path__ + "assets/img/小厨当家.d61f9db0.png";